/**
 * NextEra icon mark + wordmark. The icon is Jamee's actual approved asset
 * (public/images/icon-mark.png), not a recreation, composed here with real
 * HTML text so the wordmark stays crisp at any size and in either palette.
 */
export function Logo({
  onDark = false,
  compact = false,
  className = "",
}: {
  onDark?: boolean;
  compact?: boolean;
  className?: string;
}) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/images/icon-mark.png"
        alt=""
        width={813}
        height={965}
        className={`w-auto transition-all duration-300 ${compact ? "h-7" : "h-9"}`}
      />
      <span className="flex flex-col leading-none">
        <span
          className={`font-sans font-bold tracking-wide transition-all duration-300 ${
            compact ? "text-base" : "text-lg"
          } ${onDark ? "text-ivory" : "text-ink"}`}
        >
          NEXTERA
        </span>
        <span
          className={`mt-1 font-sans text-[10px] font-semibold tracking-[0.2em] ${
            onDark ? "text-mint" : "text-teal"
          }`}
        >
          BOOKKEEPING
        </span>
      </span>
    </span>
  );
}
